/// <amd-module name="TFS/Samples/MasterDetails/LayerComponents/Commit/CommitMasterContent" />
import * as React from "react";
import { IObservableValue } from "VSS/Core/Observable";
import { IListItemDetails, List, ListItem, ListSelection } from "VSSUI/List";
import { bindSelectionToObservable } from "VSSUI/MasterDetailsContext";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { ICommit, IPullRequest } from "../../SampleData";

export const CommitMasterContent: React.FunctionComponent<{
    initialSelectedMasterItem: IObservableValue<ICommit>;
    parentItem: IPullRequest;
}> = props => {
    const { initialSelectedMasterItem, parentItem } = props;

    const [selection] = React.useState(new ListSelection({ selectOnFocus: false }));
    const [itemProvider] = React.useState(new ArrayItemProvider(parentItem.commits));

    React.useEffect(() => {
        bindSelectionToObservable(selection, itemProvider, initialSelectedMasterItem);
    });

    return <List itemProvider={itemProvider} selection={selection} renderRow={renderListRow} width="100%" />;
};

const renderListRow = (index: number, item: ICommit, details: IListItemDetails<ICommit>, key?: string): JSX.Element => {
    return (
        <ListItem className="master-example-row" key={key || "list-item" + index} index={index} details={details}>
            <div className="flex-row flex-center h-scroll-hidden" style={{ padding: "10px 0px" }}>
                <div className="flex-noshrink" style={{ width: "32px" }} />
                <div className="flex-column flex-shrink" style={{ minWidth: 0 }}>
                    <div className="primary-text text-ellipsis">{item.description}</div>
                    <div className="secondary-text">{item.author}</div>
                </div>
            </div>
        </ListItem>
    );
};
